module.exports = __webpack_public_path__ + "img/collaborators@2x.023d72c8.webp";